import { logTransaction } from '../../common/log';
import { LogType } from '../../models/log.model';
import { ConfigName } from '../common/config';
import { sqlConnectionProvider } from '../sqlConnectionProvider';

// First version creates the Config table and inserts some basic configurations

const upgrade = async () => {
  logTransaction(LogType.Internal, '[SQLITE]: Upgrading version 0000');

  const script1 = `
    CREATE TABLE IF NOT EXISTS Config (
      Name TEXT PRIMARY KEY NOT NULL,
      Value TEXT NOT NULL
    );  
  `;
  const script2 = `
    INSERT OR IGNORE INTO Config (Name, Value)
    VALUES ('${ConfigName.SettingsEnableOfflineMode}', '1');
  `;

  await sqlConnectionProvider.run(script1);
  await sqlConnectionProvider.run(script2);

};

export default upgrade;